import React, { useState, useEffect } from "react";
import { ReactComponent as TrashIcon } from "../../img/trashicon.svg";
import { ReactComponent as PlusIcon } from "../../img/plusicon.svg";
import Select from "react-select";
import { instance2 } from "../../utils/axiosInstance";
import { ReactComponent as EditIcon } from "../../img/editicon.svg";
import { EyeIcon } from '@heroicons/react/16/solid';
import { useNavigate } from "react-router-dom";
import { ReactComponent as VerticalLine } from "../../img/verticalline.svg";
import { ReactComponent as MagnificationLogo } from "../../img/magnificationlensicon.svg";
import { formatNumber } from "src/components/numberingformat";

export default function DaftarKonsumen() {
  const [data, setData] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [loadingData, setLoadingData] = useState(true);
  const [errorData, setErrorData] = useState(null);
  const [userId, setUserId] = useState("");
    const navigate = useNavigate();
      const [searchQuery, setSearchQuery] = useState(""); // State for search input

      const storedKitchenId = localStorage.getItem("kitchenId");
      const storedUserId = localStorage.getItem("userAuthentication");
        const [schoolGrade, setSchoolGrade] = useState([]);
                const [loadingSchoolGrade, setLoadingSchoolGrade] = useState(false);
                const [schoolGradeError, setSchoolGradeError] = useState(null);
                const [clusters, setClusters] = useState([]);

  // Fetch ingredient categories

  const [formData, setFormData] = useState({
    name: "",
    regency_id: "",
    address: "",
    pic: "",
    phone: "",
    email: "",
    description: "",
    admin_id: userId,
    category_count: 0, // Initial category count
    categories: [], // Array to store selected categories
  }); 

const [deliveryOptions, setDeliveryOptions] = useState([]);
const [loadingDeliveryOptions, setLoadingDeliveryOptions] = useState(true);

useEffect(() => {
  const fetchDeliveryOptions = async () => {
    try {
      const response = await instance2.get("customers/delivery_master");
      const options = response.data || [];
      setDeliveryOptions(options);

      // Set default delivery ID = 1 if not already set
      if (!modalData.delivery) {
        setModalData((prev) => ({
          ...prev,
          delivery: "1", // Default to ID 1
        }));
      }
    } catch (error) {
      console.error("Error fetching delivery options:", error);
    } finally {
      setLoadingDeliveryOptions(false);
    }
  };

  fetchDeliveryOptions();
}, []);
  const [categoriesTambah, setCategoriesTambah] = useState([]);
          const [loadingCategories, setLoadingCategories] = useState(false);
          const [categoriesError, setCategoriesError] = useState(null);
          
useEffect(() => {
        const fetchCategories = async () => {
          try {
            setLoadingCategories(true);
            setCategoriesError(null);
            // Replace 'categories' with your actual API endpoint for categories
            const response = await instance2.get("customers/types");
            const apiCategories = response.data?.data || response.data || [];
            setCategoriesTambah(apiCategories);
          } catch (error) {
            console.error("Error fetching categories:", error);
            setCategoriesError(error.message || "Failed to fetch categories");
          } finally {
            setLoadingCategories(false);
          }
        };
      
        fetchCategories();
      }, []);

useEffect(() => {
  const fetchClusters = async () => {
    try {
      const response = await instance2.get("customers/clusters");
      setClusters(response.data?.data || response.data || []);
    } catch (err) {
      console.error("Failed to fetch clusters", err);
    }
  };

  fetchClusters();
}, []);

 useEffect(() => {
        const fetchSchoolGrades = async () => {
          try {
            setLoadingSchoolGrade(true);
            setSchoolGradeError(null);
            // Replace 'categories' with your actual API endpoint for categories
            const response = await instance2.get("customers/school_master");
            const apiCategories = response.data?.data || response.data || [];
            setSchoolGrade(apiCategories);
          } catch (error) {
            console.error("Error fetching categories:", error);
            setSchoolGradeError(error.message || "Failed to fetch school grades");
          } finally {
            setLoadingSchoolGrade(false);
          }
        };
      
        fetchSchoolGrades();
      }, []);

  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    if (storedUserId) {
      setUserId(parseInt(storedUserId, 10)); // Ensure userId is an integer
      setFormData((prev) => ({
        ...prev,
        admin_id: parseInt(storedUserId, 10), // Automatically update admin_id
      }));
    }
  }, []);

  // Fetch supplier data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await instance2.get(`customers/kitchen/${storedKitchenId}`);
        setData(response.data); // Access the appropriate field in the response
      } catch (err) {
        setErrorData(err.message);
      } finally {
        setLoadingData(false);
      }
    };
  
    fetchData();
  }, []);
  

  const filteredData = data.filter((item) => {
    const searchValue = searchQuery.toLowerCase();

    return (
      (item.name?.toLowerCase().includes(searchValue) || false) ||
      (item.pack?.toString().toLowerCase().includes(searchValue) || false) ||
      (item.type_id?.toString().toLowerCase().includes(searchValue) || false) 
    );
  });

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
  
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const paginatedData = filteredData.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  
    const handlePreviousPage = () => {
      if (currentPage > 1) setCurrentPage(currentPage - 1);
    };
  
    const handleNextPage = () => {
      if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };
  
    // Determine which page numbers to show
    let pageNumbers = [];
    const maxVisiblePages = 5;
  
    if (totalPages <= maxVisiblePages) {
      pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      if (currentPage <= 3) {
        // Near the beginning
        pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
      } else if (currentPage >= totalPages - 2) {
        // Near the end
        pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
      } else {
        // In the middle
        pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
      }
    }

const handleEditSave = async () => {
  try {
    // Recalculate pack
    const totalQty = getClusterFields().reduce((total, cluster) => {
      const qtyValue = modalData[cluster.qtyKey];
      return total + (qtyValue || 0); // Sum up the qty values
    }, 0);

    // Update pack value in modalData
    modalData.pack = totalQty;

    // Prepare payload for customer update
    const payload = {
      kitchen_id: parseInt(storedKitchenId, 10),
      name: modalData.name,
      code: modalData.code || "",
      pack: totalQty, // Send recalculated pack
      type_id: modalData.type_id,
      address: modalData.address,
      admin_id: storedUserId,
    };

    // Add qty_1 to qty_10 if present
    for (let i = 1; i <= 10; i++) {
      const key = `qty_${i}`;
      if (modalData.hasOwnProperty(key)) {
        payload[key] = modalData[key];
      }
    }

    // Update customer data
    await instance2.put(`/customers/${modalData.id}`, payload);

    // Send customer cluster data
    const clusterPosts = getClusterFields()
      .map((cluster) => {
        const qty = parseFloat(modalData[cluster.qtyKey]);
        if (!qty || qty <= 0) return null; // Skip if no quantity or invalid

        return instance2.post("/customers/customer_clusters", {
          cluster_id: cluster.id,
          cluster_name: cluster.name,
          customer_id: modalData.id,
          qty,
          delivery: modalData[`delivery_${cluster.id}`] || "1", // Default to 1 if not provided
          admin_id: localStorage.getItem("userAuthentication"),
        });
      })
      .filter(Boolean); // Remove any null values

    // Wait for all cluster posts to complete
    await Promise.all(clusterPosts);

    console.log("All cluster posts completed");

    setModalData(null); // Close the modal

    // Re-fetch data and update the list
    const res = await instance2.get(`/customers/kitchen/${storedKitchenId}`);
    setData(res.data);
  } catch (err) {
    alert("Failed to update customer: " + err.message);
  }
};


   const isFormValid = () => {
          return (
            modalData.name !== "" &&
            modalData.pack !== "" &&
            modalData.address !== "" &&
            modalData.type_id !== ""
          );
        };
        
const getClusterFields = () => {
    if (!modalData || !clusters) return [];

    const filteredClusters = clusters.filter((cluster) => {
      const groupMatches = cluster.group_id === modalData.type_id;

      if (modalData.type_id === 1 && modalData.school_level) {
        return groupMatches && cluster.level_id === modalData.school_level;
      }

      return groupMatches;
    });

    const clusterFields = [];

    for (let i = 1; i <= 10; i++) {
      const nameKey = `cluster_name_${i}`;
      const qtyKey = `qty_${i}`;
      const deliveryKey = `delivery_${i}`;

      const clusterName = modalData[nameKey];
      const qtyValue = modalData[qtyKey] ?? "";
      const deliveryValue = modalData[deliveryKey] ?? ""; // Get the delivery value from modalData

      if (clusterName !== undefined) {
        // Check if this clusterName exists in the filteredClusters
        const matchedCluster = filteredClusters.find((c) => c.name === clusterName);

        if (matchedCluster) {
          clusterFields.push({
            id: matchedCluster.id, // Ensure `id` is included
            name: clusterName,
            qtyKey,
            value: qtyValue,
            deliveryKey,
            deliveryValue: deliveryValue
          });
        }
      }
    }

    return clusterFields;
  };


  // Handle change in delivery option for a specific cluster
  const handleDeliveryChange = (clusterId, deliveryValue) => {
    setModalData((prev) => ({
      ...prev,
      [`delivery_${clusterId}`]: deliveryValue, // Update delivery for the specific cluster
    }));
  };


const handleClusterQtyChange = (qtyKey, value) => {
  // Update the specific cluster quantity
  setModalData((prev) => {
    const updatedModalData = {
      ...prev,
      [qtyKey]: value,
    };

    // Recalculate pack (sum of all non-null qty values)
    const totalQty = getClusterFields().reduce((total, cluster) => {
      const qtyValue = updatedModalData[cluster.qtyKey];
      return total + (qtyValue || 0); // Add qty to total if it's not null or undefined
    }, 0);

    updatedModalData.pack = totalQty; // Update pack with the new total quantity

    return updatedModalData;
  });
};
 console.log("Modal Data:", modalData); 
  return (
    <div className="p-4">
  

  {/* Table Section */}
  
  <div className="flex flex-col items-start md:flex-row lg:flex-row md:items-center lg:items-center justify-between">
      <h2 className="block text-black text-xl sm:text-2xl my-2 font-medium">Daftar Konsumen</h2>
      <button
        type="button"
        onClick={() => navigate("/tambahkonsumen")}
        className="rounded-[25px] px-8 py-4 bg-merah-no hover:bg-merah-hover text-white text-xxs md:text-xxs lg:text-base"
      >
        Tambah Konsumen
      </button>
    </div>
  {loadingData && <p>Loading...</p>}
  {errorData && <p className="text-red-500">{errorData}</p>}
  {!loadingData && data.length === 0 && <p>No data available</p>}
  {!loadingData && data.length > 0 && (
    <>  
    {/* Search Bar */}
          <div className="flex py-4 rounded-[50px] flex-row justify-start items-center gap-2">
            <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center justify-start">
              <MagnificationLogo className="h-6 w-6" />
              <VerticalLine className="mx-1" />
              <input
                type="text"
                placeholder="Telusuri data berdasarkan kota, nama pemasok, atau nomor telepon"
                className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-xxs md:text-xxs lg:text-base"
                style={{
                  width: `${"Telusuri data berdasarkan kota, nama pemasok, atau nomor telepon".length}ch`,
                }}
                value={searchQuery} // Controlled input
                onChange={(e) => setSearchQuery(e.target.value)} // Update search query
              />
            </div>
          </div>
      <table className="table-fixed w-full border-gray-300">
        <thead>
          <tr className="bg-white">
            <th className="w-[50px] border-b border-gray-300 px-2 sm:px-4 py-2 rounded-tl-[15px] text-center text-xxs md:text-xxs lg:text-base">
              No
            </th>
            <th className="w-1/3  border-b border-gray-300 px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
              Nama
            </th>
            <th className="text-right border-b border-gray-300 px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base text-center">
               Porsi (Proposal)
            </th>
                <th
                  className="w-1/2 border-b border-gray-300 px-2 sm:px-4 py-2 rounded-tr-[15px] text-center text-xxs md:text-xxs lg:text-base"
                >
                  Aksi
                </th>
          </tr>
        </thead>
        <tbody>
                  {[
            ...paginatedData,
            ...Array.from({ length: itemsPerPage - paginatedData.length }).map((_, index) => ({
              empty: true, // Add an "empty" object for invisible rows
            })),
          ].map((item, index) => (
            <tr
            key={item.empty ? `empty-${index}` : `row-${item.id}`}
            className={`hover:bg-gray-200 ${
              index % 2 === 0 ? "bg-bg-gray-100" : "bg-white"
            } ${item.empty ? "invisible border-b border-transparent" : "border-b border-gray-300"}`}
          >
              <td className="px-2 sm:px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">
              {index + 1 + (currentPage - 1) * itemsPerPage}
              </td>
              <td className="px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
                {item.name}
              </td>
              <td className="px-2 text-right sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
                {formatNumber(item.pack)}
              </td>
                                <td className="px-4 py-2 text-center">
                                <button
                        className="text-gray-500 p-2 rounded hover:text-green-500"
                        onClick={() => setModalData({ ...item })}
                      >
                        <EditIcon className="w-5 h-5" />
                      </button>
                                </td>
            </tr>
          ))}
        </tbody>
      </table>
      {modalData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Ubah Customer</h3>
            <div className="space-y-4">
              
      {/* Tipe Penerima Manfaat */}
            <div className="">
            <label className="block text-sm font-medium text-gray-700">Tipe Penerima Manfaat</label>
        <select
          className="mt-1 block w-full border px-3 py-2 rounded-md text-sm"
          value={modalData.type_id}
          disabled
          onChange={(e) =>
            setModalData({ ...modalData, type_id: e.target.value })
          }
        >
          <option value="" disabled>Pilih Kategori</option>
          {categoriesTambah.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
      </div>

      {/* Jenjang Sekolah */}
      {modalData.type_id === 1 && (
            <div className="">
            <label className="block text-sm font-medium text-gray-700">Jenjang Sekolah</label>
          <select
            className="mt-1 block w-full border px-3 py-2 rounded-md text-sm"
            value={modalData.school_level}
          disabled
            onChange={(e) =>
              setModalData({ ...modalData, school_level: e.target.value })
            }
          >
            <option value="" disabled>Pilih Kategori</option>
            {schoolGrade.map((grade) => (
              <option key={grade.id} value={grade.id}>
                {grade.name}
              </option>
            ))}
          </select>
        </div>
      )}

              <div>
                <label className="block text-sm font-medium text-gray-700">Nama</label>
                <input
                  type="text"
                  value={modalData.name}
                  onChange={(e) => setModalData({ ...modalData, name: e.target.value })}
                  className="mt-1 block w-full border px-3 py-2 rounded-md text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Alamat</label>
                <input
                  type="text"
                  value={modalData.address}
                  onChange={(e) => setModalData({ ...modalData, address: e.target.value })}
                  className="mt-1 block w-full border px-3 py-2 rounded-md text-sm"
                />
              </div>
             {/* Update delivery option in modal */}
{getClusterFields().map((cluster, index) => (
        <div key={index}>
          <label className="block text-sm font-medium text-gray-700">{cluster.name}</label>
          <input
  type="text"
  value={
    modalData[cluster.qtyKey] !== undefined && modalData[cluster.qtyKey] !== null
      ? formatNumber(modalData[cluster.qtyKey])
      : ""
  }
  onChange={(e) => {
    const rawValue = e.target.value.replace(/\./g, ''); // Remove dots
    const parsed = parseInt(rawValue, 10);
    handleClusterQtyChange(cluster.qtyKey, isNaN(parsed) ? 0 : parsed);
  }}
  className="mt-1 block w-full border px-3 py-2 rounded-md text-sm"
/>


          <div className="flex gap-4">
            <label className="block text-gray-700 text-sm">Waktu Pengantaran</label>
            <div className="flex gap-4">
              {deliveryOptions.map((option) => (
                <label key={option.id} className="flex items-center gap-2 text-sm">
                  <input
                    type="radio"
                    name={`delivery_${cluster.id}`} // Name based on cluster.id to separate each group of radio buttons
                    value={option.id}
                    checked={modalData[`delivery_${cluster.id}`] === option.id} // Check if this radio is selected based on modalData
                    onChange={() => handleDeliveryChange(cluster.id, option.id)} // Update delivery value
                  />
                  {option.name}
                </label>
              ))}
            </div>
          </div>
        </div>
      ))}
              <div>
                <div>
  <label className="block text-sm font-medium text-gray-700">Jumlah Porsi</label>
  <input
    type="text"
    value={
      modalData.pack !== undefined && modalData.pack !== null
        ? formatNumber(modalData.pack)
        : ""
    }
    onChange={(e) => {
      const rawValue = e.target.value.replace(/\./g, ''); // Hilangkan titik
      const parsed = parseInt(rawValue, 10); // Parse ke angka
      setModalData({ ...modalData, pack: isNaN(parsed) ? 0 : parsed });
    }}
    className="mt-1 block w-full border px-3 py-2 rounded-md text-sm"
    disabled
/>
</div>

              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  className="px-4 py-2 bg-gray-300 text-sm rounded"
                  onClick={() => setModalData(null)}
                >
                  Batal
                </button>
                <button
                  className={`px-4 py-2 text-sm rounded ${
                isFormValid()
                  ? " bg-merah-no text-white hover:bg-merah-hover"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
              }`}
              disabled={!isFormValid()}
                  onClick={handleEditSave}
                >
                  Simpan
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
         
{/* Pagination Controls */}
<div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
      {/* Previous Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
      >
        <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <span className="font-bold text-lg sm:text-2xl">{">"}</span>
      </button>
    </div>
    </>
  )}
</div>

  );
}
